export const CONFIG = {
  FRONTEND_HOST: import.meta.env.VITE_FRONTEND_HOST as string,
  API_HOST: import.meta.env.VITE_API_HOST as string,
  DEV_TENANT: import.meta.env.VITE_DEV_TENANT as string | undefined,
  /** Force `localhost` to behave like the bare root domain — lets you drive
   *  the super-admin console locally without wildcard DNS. */
  DEV_ROOT: import.meta.env.VITE_DEV_ROOT === 'true',
  /** URL prefix for the super-admin console (login + all admin pages). Set
   *  this to a secret, non-guessable value in production so the admin login
   *  isn't sitting at the obvious `/admin`. Defaults to `/admin` for dev. */
  CONSOLE_PATH:
    (import.meta.env.VITE_CONSOLE_PATH as string | undefined)?.replace(/\/+$/, '') || '/admin',
  ENABLE_BIOMETRIC: import.meta.env.VITE_ENABLE_BIOMETRIC === 'true',
  ENABLE_OUTBOX: import.meta.env.VITE_ENABLE_OUTBOX === 'true',
  /** Timesheets feature — the BE endpoints (`/api/timesheets*`) haven't
   *  shipped yet. Default off so the sidebar entry doesn't dead-end
   *  every user in a 404 toast. Flip via env when the BE lands. */
  ENABLE_TIMESHEETS: import.meta.env.VITE_ENABLE_TIMESHEETS === 'true',
  /** Sentry DSN — leave empty in local dev to skip init. */
  SENTRY_DSN: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '',
  /** e.g. `production`, `staging`, `development`. */
  SENTRY_ENVIRONMENT:
    (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? 'development',
  /** Deployment SHA / semver tag — set from CI. */
  SENTRY_RELEASE: (import.meta.env.VITE_SENTRY_RELEASE as string | undefined) ?? '',
  /** 0.0 - 1.0 for error events; separate from performance sample rate. */
  SENTRY_SAMPLE_RATE: Number(import.meta.env.VITE_SENTRY_SAMPLE_RATE ?? '1'),
  SENTRY_TRACES_SAMPLE_RATE: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0'),
} as const;

if (!CONFIG.FRONTEND_HOST || !CONFIG.API_HOST) {
  throw new Error(
    'Missing VITE_FRONTEND_HOST or VITE_API_HOST — set both in .env before building.',
  );
}
